module.exports = {"description":"","displayName":"Divider","methods":[],"props":{"cssMap":{"defaultValue":{"value":"require( './divider.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/Divider-props.json
// module id = 424
// module chunks = 0